import AxiosClient from "../../../services/axios.services";

class FormatosServices {
  getSancionesDocs = (params) =>
    AxiosClient.get("/api/app/sanciones_plantilla_formatos_oficiales/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  getSancionesDoc = (id) =>
    AxiosClient.get(
    `/api/app/sanciones_plantilla_formatos_oficiales/${id}`,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  saveSancionesDoc = (data) =>
    AxiosClient.post("/api/app/sanciones_plantilla_formatos_oficiales/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editSancionesDoc = (id, data) =>
    AxiosClient.put(`/api/app/sanciones_plantilla_formatos_oficiales/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteSancionesDoc = (id) =>
    AxiosClient.delete(`/api/app/sanciones_plantilla_formatos_oficiales/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new FormatosServices();